import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import LoadingSpinner from '../shared/LoadingSpinner'

interface ProtectedRouteProps {
  children: ReactNode
  requiredRole?: 'admin' | 'professor' | 'aluno' | ('admin' | 'professor' | 'aluno')[]
}

const ProtectedRoute = ({ children, requiredRole }: ProtectedRouteProps) => {
  const { profile, loading, isAuthenticated } = useAuth()

  if (loading) {
    return <LoadingSpinner fullScreen={true} />
  }

  // Usar a função isAuthenticated() corretamente e não depender de user para sessão válida
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />
  }

  // Se há role necessário mas o perfil ainda não carregou, manter spinner até carregar
  if (requiredRole && !profile) {
    return <LoadingSpinner fullScreen={true} />
  }

  const hasRequiredRole = () => {
    if (!requiredRole) return true
    if (Array.isArray(requiredRole)) {
      return requiredRole.includes(profile?.role as any)
    }
    return profile?.role === requiredRole
  }

  if (requiredRole && !hasRequiredRole()) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center p-8">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
            <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Acesso Negado</h2>
          <p className="text-gray-600 mb-4">
            Você não tem permissão para acessar esta página.
          </p>
          <p className="text-sm text-gray-500">
            Role necessário: <span className="font-medium">{requiredRole}</span><br />
            Seu role atual: <span className="font-medium">{profile?.role || 'Não definido'}</span>
          </p>
          <button
            onClick={() => window.history.back()}
            className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Voltar
          </button>
        </div>
      </div>
    )
  }

  return <>{children}</>
}

export default ProtectedRoute